import { LoadingButton } from '@mui/lab';
import {
  TableCell,
  TableRow
} from '@mui/material';
import { viewWinnerResultAPI } from '@src/api/rewards-management';
import { usePartnerDropdownContext } from '@src/context/PartnerDropdown';
import { useToasterContext } from '@src/context/Toaster';
import { AlertType } from '@src/lib/types/toaster';
import moment from 'moment';
import numeral from 'numeral';
import { useState } from 'react';

const TableRowItem = (props: any) => {
  const { triggerOpen } = useToasterContext();
  const [loading, setLoading] = useState(false);
  const { state: { selectedPartnerId } } = usePartnerDropdownContext();

  const onViewWinners = async() => {
    try {
      setLoading(true);
      const result = await viewWinnerResultAPI({ id: props.id, partnerId: selectedPartnerId });

      setLoading(false);
      props.onViewWinners(result);
    } catch (error: any) {
      setLoading(false);
      triggerOpen({
        type: AlertType.error,
        title: "VIEW WINNERS",
        message: error.message
      });
    }
  }

  return (
    <TableRow hover tabIndex={-1} role="checkbox">
      <TableCell sx={{ fontWeight: 700, color: "#2D60FF" }} align="left">{props.code}</TableCell>
      <TableCell align="center" >{props.description}</TableCell>
      <TableCell align="center">{numeral(props.totalRedeemedTickets).format("0,000")}</TableCell>
      <TableCell align="center" >{moment(props.drawDate).format("DD-MM-YYYY")}</TableCell>
      <TableCell align="center" >
        <LoadingButton loading={loading} onClick={onViewWinners} 
          sx={{borderRadius: 5, px: 2, color: "#457DBF", bgcolor: "#E5EFF4"}}>
          VIEW WINNERS
        </LoadingButton>
      </TableCell>
    </TableRow>
  );
}

export default TableRowItem;
